import type { IProposal } from '@shared/models/proposals.model';
import type { ReportSlideKind } from '@shared/models/report-slides.model';

type ReportThumbnailContentKeyInput = {
  projectId: number;
  projectUpdatedAt: string;
  versionId: string | undefined;
  coverImageUrl: string | null | undefined;
  pageCount: number;
  gfa: number;
  target: number | null;
  hiddenSharedSlides: readonly ReportSlideKind[] | undefined;
  hiddenPageKeys?: readonly string[];
  proposals: readonly Pick<
    IProposal,
    'id' | 'name' | 'actionIds' | 'report_hidden_slides'
  >[];
};

/**
 * Value-stable fingerprint of report visuals. Used to reuse thumbnail PNGs
 * across Report unmount/remount when the user leaves and returns without edits.
 */
export const buildReportThumbnailContentKey = (
  input: ReportThumbnailContentKeyInput,
): string =>
  JSON.stringify({
    projectId: input.projectId,
    projectUpdatedAt: input.projectUpdatedAt,
    versionId: input.versionId ?? '',
    coverImageUrl: input.coverImageUrl ?? '',
    pageCount: input.pageCount,
    gfa: input.gfa,
    target: input.target,
    hiddenSharedSlides: input.hiddenSharedSlides ?? [],
    hiddenPageKeys: input.hiddenPageKeys ?? [],
    proposals: input.proposals.map((proposal) => ({
      id: proposal.id,
      name: proposal.name,
      actionIds: proposal.actionIds,
      hidden: proposal.report_hidden_slides ?? [],
    })),
  });
